module.exports = __webpack_public_path__ + "static/scale-model-of-conrad-caldwell-house-in-louisville-kentucky-7192ae27c1b834c2875fef7c2c645a95.png";